//React
import { decode as base64_decode, encode as base64_encode } from 'base-64';
import React from 'react';
import ReactDOM from 'react-dom';
import { inserirCookie, retornarCookie } from '../src/services/cookieservice';
import { retornaBuscaBusster } from '../src/services/buscaBusster';
import './index.css';

// Materialize
import 'materialize-css/dist/css/materialize.min.css';
import 'materialize-css/dist/js/materialize.js';

import App from './components/AppComponent/AppComponent';


ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);
